<template>
    <div class="here-map">
        <div ref="map"
             style="width:100% !important;height:100% !important;top:0px !important;left:0px !important; position: fixed !important; "></div>
    </div>
</template>

<script>
  /*global H*/

  import Vue from 'vue'
  import ShipIcon from './ShipIcon'
  import { difference } from 'lodash'

  export default {
    name: 'HereMap',
    data () {
      return {
        map: {},
        platform: {},
        markers: {},
        icons: {},
        group: {},
      }
    },
    props: {
      appId: String,
      apiKey: String,
      lat: String,
      lng: String,
      ships: Array,
    },
    watch: {
      ships () {
        console.log('Rendering ships')
        this.renderShips()
      },
    },
    methods: {
      renderShips () {
        const currentShips = Object.keys(this.markers)

        // Remove markers filtered out
        difference(currentShips, this.ships.map(s => s.id)).map(shipId => {
          const marker = this.markers[shipId];
          delete this.markers[shipId]
          this.group.removeObject(marker)
        })

        this.ships.map(ship => this.renderShip(ship))

      },
      zoomToShip (shipId) {
        const marker = this.markers[shipId]

        if (!marker) return

        this.map.getViewModel().setLookAtData({
          position: marker.getGeometry(),
          zoom: 10,
        })

        setTimeout(() => {
          this.openTooltip(shipId)
        }, 100)

      },
      renderShip (ship) {
        const icon = new Vue({
          ...ShipIcon,
          propsData: {
            ship,
          },
        })

        icon.$mount()

        let marker = this.markers[ship.id]

        if (!marker) {
          marker = this.map.addObject(new H.map.DomMarker({ lat: ship.location.lat, lng: ship.location.lng }, {
            icon: new H.map.DomIcon(icon.$el),
          }))

          marker.setData(ship.id)

          this.group.addObject(marker)
          this.markers[ship.id] = marker
          return
        }

        marker.setIcon(new H.map.DomIcon(icon.$el))
        marker.setGeometry({ lat: ship.location.lat, lng: ship.location.lng })
      },
      openTooltip (shipId) {
        const el = document.querySelector(`.ship-${shipId}`)

        if (!el) return

        const showing = el.style.display === 'block'

        const tooltips = document.querySelectorAll('.ship-tooltip')

        for (let i = 0; i < tooltips.length; i++) {
          tooltips[i].style.display = 'none'
        }

        el.style.display = showing ? 'none' : 'block'
      },
    },
    created () {
      this.platform = new H.service.Platform({
        apikey: this.apiKey,
      })
    },
    mounted () {
      const defaultLayers = this.platform.createDefaultLayers()

      this.map = new H.Map(
        this.$refs.map,
        defaultLayers.vector.normal.map,
        {
          zoom: 1,
          center: { lng: this.lng, lat: this.lat },
        },
      )

      const ui = H.ui.UI.createDefault(this.map, defaultLayers)
      const behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map))

      this.group = new H.map.Group()
      this.map.addObject(this.group)

      this.group.addEventListener('tap', (evt) => {
        this.openTooltip(evt.target.getData())
        evt.stopPropagation()
      })

      // this.map.addEventListener('tap', (evt) => {
      //   const el = document.querySelector(`.ship-${evt.target.getData()}`);
      //
      //   if (!el) return;
      //
      //   el.style.display = 'none';
      //   evt.stopPropagation()
      // })

      this.map.addEventListener('mapviewchange', (e)  => {
        if (!e.newValue || !e.newValue.lookAt) return
        const zoom = e.newValue.lookAt.zoom;

        const buttons = document.querySelectorAll('.icon-btn');
        let className;

        if (zoom > 8) {
          className = 'close'
        } else {
          className = 'far'
        }

        for (let i = 0; i < buttons.length; i++) {
          buttons[i].className = `focus:outline-none icon-btn ${className}`;
        }
      });

      // setInterval(() => {
      //   this.ship.lat += 0.01
      //   this.renderShip(this.ship)
      // }, 1000)

      window.addEventListener('resize', () => this.map.getViewPort().resize())
    },
  }
</script>
